import NodeTypeRules from "./NodeTypeRules";

class NodeRules {
  node: $TSFixMe;

  nodeTypeRules: $TSFixMe;

  constructor(node: $TSFixMe) {
    this.node = node;
    this.nodeTypeRules = NodeTypeRules.find(node);
  }

  get(rule: $TSFixMe, a: $TSFixMe, b: $TSFixMe, c: $TSFixMe) {
    return this.nodeTypeRules.get(rule, a, b, c);
  }
}

export default NodeRules;
